import React, { ChangeEvent, useState } from 'react'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { CreatePlpType } from './CreatePlp'
import './CreatePlp.scss'

type FormProps = {
  children?: React.ReactNode
  errors: FieldErrors<CreatePlpType>
  register: UseFormRegister<CreatePlpType>
  setBVN: (value: string) => void
  setNIN: (value: string) => void
  onNext: () => void
  handlePrev: () => void
  publicAccess?: boolean
}

const PlpCompanyDetailsStepTwo: React.FC<FormProps> = ({
  errors,
  register,
  onNext,
  handlePrev,
  publicAccess,
  setBVN,
  setNIN,
}) => {
  const [fieldErrors, setFieldErrors] = useState({
    nin: false,
    bvn: false,
  })
  const validateNotEmpty = (value: string) => value.trim() !== ''

  const updateFieldError = (field: string, value: string) => {
    setFieldErrors((prev) => ({
      ...prev,
      [field]: validateNotEmpty(value),
    }))
  }

  const handleInputChange = (field: string) => (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    updateFieldError(field, value)
  }

  const isNextButtonDisabled = !Object.values(fieldErrors).every((error) => error === true)

  return (
    <div className='row'>
      <div className='col-md-6 my-4'>
        <div className='step-title'>Deferred Payment Details</div>
      </div>
      <div className='col-sm-6 text-sm-end my-4'>
        <div className='step-page-number'>Page 2 of 3</div>
      </div>

      <div className={publicAccess ? 'col-md-10 col-lg-8' : 'col-md-10 col-lg-6'}>
        <div className='form-group mb-3'>
          <label htmlFor='bvn'>
            Customer&apos;s BVN <span className='text-danger'>*</span>
          </label>
          <input
            type='text'
            id='bvn'
            className={errors.bvn ? 'form-control is-invalid' : 'form-control'}
            {...register('bvn', {
              onChange: (e) => {
                handleInputChange('bvn')(e)
                setBVN(e.target.value)
              },
            })}
            placeholder='22278379533'
          />
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='NIN'>
            NIN <span className='text-danger'>*</span>
          </label>
          <input
            type='number'
            id='NIN'
            className={errors.nin ? 'form-control is-invalid' : 'form-control'}
            {...register('nin', {
              required: 'NIN is required',
              onChange: (event) => {
                handleInputChange('nin')(event)
                setNIN(event.target.value)
              },
            })}
          />
        </div>

        <div className='row'>
          <div className='col-12 col-sm-4 col-md-4 mt-1'>
            <button onClick={handlePrev} className='btn btn-respond-req'>
              Previous
            </button>
          </div>
          <div className='col-12 col-sm-4 col-md-4 mt-1'>
            <button
              onClick={onNext}
              className='btn btn-respond-req col'
              disabled={isNextButtonDisabled}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlpCompanyDetailsStepTwo
